import React from 'react';
import { Link } from 'react-router-dom';

const OurHomesContent = () => {
  return (
    <div className="py-16 px-8" style={{ backgroundColor: '#eef2f6' }}>
      <div className="max-w-6xl mx-auto">
        {/* Main Heading */}
        <h1 className="text-5xl md:text-6xl font-light mb-8" style={{ color: '#2b3d57' }}>
          Our Homes
        </h1>

        {/* Introduction Paragraph */}
        <p className="text-xl md:text-2xl mb-6 leading-relaxed" style={{ color: '#2b3d57' }}>
          At Testa Residential Care, each home provides a safe, stable, and nurturing environment where young people can
          feel secure, supported, and valued. We develop tailored care plans for each young person, ensuring that support
          meets their unique needs and aspirations. Building trusting relationships with young people, families, and
          professionals is central to our approach, helping children feel understood, respected, and encouraged.
        </p>

        {/* Regular Paragraphs */}
        <p className="text-base mb-8 leading-relaxed" style={{ color: '#2b3d57' }}>
          Beyond therapeutic care, we offer opportunities for social, creative, and community activities that promote
          confidence, independence, and personal growth, ensuring that every young person can thrive in a supportive and
          engaging environment.
        </p>

        {/* View Care Homes Button */}
        <div className="mb-8">
          <Link
            to="/care-homes"
            className="inline-block px-10 py-3 rounded-full border-2 border-[#2f4c74] text-[#2f4c74] transition duration-300 hover:bg-[#2f4c74] hover:text-white"
          >
            View Care Homes
          </Link>
        </div>

        {/* Image Grid */}
        <div
          id="care-homes"
          className="flex md:grid md:grid-cols-3 gap-6 overflow-x-auto md:overflow-visible snap-x snap-mandatory"
        >
          <div className="min-w-[80%] md:min-w-0 snap-center">
            <img
              src="https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1200&q=80"
              alt="Beech Grove House - Kitchen and Dining Area"
              className="w-full h-64 object-cover rounded"
            />
          </div>
          <div className="min-w-[80%] md:min-w-0 snap-center">
            <img
              src="https://images.unsplash.com/photo-1502005097973-6a7082348e28?auto=format&fit=crop&w=1200&q=80"
              alt="Mulberry House - Exterior with Garden"
              className="w-full h-64 object-cover rounded"
            />
          </div>
          <div className="min-w-[80%] md:min-w-0 snap-center">
            <img
              src="https://images.unsplash.com/photo-1507089947368-19c1da9775ae?auto=format&fit=crop&w=1200&q=80"
              alt="The Brow - Bedroom"
              className="w-full h-64 object-cover rounded"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurHomesContent;
